export const environment = {
  production: false,
  // App Check debug token (auto-registered by Ops/register-app.js — do not edit)
  appCheckDebugToken: "81e0e56f-d91a-4cbb-8edf-f46462d7a9d6",
  // reCAPTCHA Enterprise site key (dev)
  recaptchaSiteKey: "6LcZhYktAAAAAMWD3iSP9SuCw8RdztN5uvAWGiQp",
  firebaseConfig: {
    apiKey: "AIzaSyDVKdKB4ywFpJbgk0eitXVwG7YeSjwGCa4",
    authDomain: "chareety-dev-4.firebaseapp.com",
    projectId: "chareety-dev-4",
    storageBucket: "chareety-dev-4.firebasestorage.app",
    messagingSenderId: "768587471920",
    appId: "1:768587471920:web:f45a9342ab32f3e29fa1f5",
    measurementId: "G-061S2PCY0Z"
  },
  stripeKey: "pk_test_51LsogEEQkKnpYqBZiG4X70WG2WnI94TzKZNrBWLfTU0o5hrFpPZEUOf39VioWABFeB0Y8nD6YZd6pEH9aVsbp60X005oYTEVbS",
  appUrls: {
    onboard: "https://onboard-dev.chareety.com",
    partners: "https://partners-dev.chareety.com",
    marketing: "https://dev.chareety.com",
  },
};
